export default __webpack_public_path__ + "static/media/slideaccesorio2.7e754b10.png";